var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDadosHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12H15.75V13.5H17.25V12Z",
    fill: "#0092C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12H6.75V13.5H12.75V12Z",
    fill: "#0092C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9H15.75V10.5H17.25V9Z",
    fill: "#0092C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9H6.75V10.5H12.75V9Z",
    fill: "#0092C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 6H6.75V7.5H17.25V6Z",
    fill: "#0092C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 1.5H5.25C4.8523 1.5004 4.471 1.65856 4.18978 1.93978C3.90856 2.221 3.7504 2.6023 3.75 3V21.75C3.75 21.9489 3.82902 22.1397 3.96967 22.2803C4.11032 22.421 4.30109 22.5 4.5 22.5H5.25C5.36645 22.5001 5.48131 22.473 5.58546 22.4209C5.68962 22.3688 5.78019 22.2932 5.85 22.2L7.5 20.0002L9.15 22.2C9.22284 22.2887 9.31443 22.3601 9.41817 22.4091C9.52192 22.4582 9.63525 22.4836 9.75 22.4836C9.86475 22.4836 9.97808 22.4582 10.0818 22.4091C10.1856 22.3601 10.2772 22.2887 10.35 22.2L12 20.0002L13.65 22.2C13.7228 22.2887 13.8144 22.3601 13.9182 22.4091C14.0219 22.4582 14.1352 22.4836 14.25 22.4836C14.3648 22.4836 14.4781 22.4582 14.5818 22.4091C14.6856 22.3601 14.7772 22.2887 14.85 22.2L16.5 20.0002L18.15 22.2C18.2198 22.2932 18.3104 22.3688 18.4146 22.4209C18.5187 22.4729 18.6336 22.5 18.75 22.5H19.5C19.6989 22.5 19.8897 22.421 20.0303 22.2803C20.171 22.1397 20.25 21.9489 20.25 21.75V3C20.2495 2.60232 20.0914 2.22105 19.8102 1.93984C19.529 1.65864 19.1477 1.50046 18.75 1.5ZM18.75 20.4998L17.1 18.3C17.0272 18.2113 16.9356 18.1399 16.8318 18.0909C16.7281 18.0418 16.6148 18.0164 16.5 18.0164C16.3852 18.0164 16.2719 18.0418 16.1682 18.0909C16.0644 18.1399 15.9728 18.2113 15.9 18.3L14.25 20.4998L12.6 18.3C12.5272 18.2113 12.4356 18.1399 12.3318 18.0909C12.2281 18.0418 12.1148 18.0164 12 18.0164C11.8852 18.0164 11.7719 18.0418 11.6682 18.0909C11.5644 18.1399 11.4728 18.2113 11.4 18.3L9.75 20.4998L8.1 18.3C8.02716 18.2113 7.93557 18.1399 7.83183 18.0909C7.72808 18.0418 7.61475 18.0164 7.5 18.0164C7.38525 18.0164 7.27192 18.0418 7.16817 18.0909C7.06443 18.1399 6.97284 18.2113 6.9 18.3L5.25 20.4998V3H18.75V20.4998Z",
    fill: "#0092C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDadosHome);
export default __webpack_public_path__ + "static/media/dadosHome.332e623e526d10a7f55424679fe596c6.svg";
export { ForwardRef as ReactComponent };